module.exports = __webpack_public_path__ + "img/floor_f9_02.5777eb44.png";